(function (Drupal) {

  Drupal.behaviors.footerToTop = {
    attach: function (context) {
      'use strict';
      var footerLink = context.querySelector('.footer-to-top');
      var topOfPage = context.querySelector('[name="content-top"]');

      if(footerLink != null && topOfPage != null) {
        footerLink.addEventListener('click', () => {
          scrollIt(topOfPage);
        });
      }
    }
  }

})(Drupal);
